module.exports = __webpack_public_path__ + "img/top_happytablet.9ebd7a65.jpg";